import SVTrackedUpgradeButtonContainer from '@apps/www/src/www/containers/SVTrackedUpgradeButtonContainer';
import SVModal, { useModalClose } from '@pkgs/shared-client/components/SVModal';
import SVUpgradeFeaturesList from '@pkgs/shared-client/components/SVUpgradeFeaturesList';
import AllowedFeature from '@pkgs/shared/enums/AllowedFeature';
import UpgradeButtonSource from '@pkgs/shared/enums/UpgradeButtonSource';
import { getUpsellBenefits } from '@pkgs/shared/plans';
import { ModalContent } from './SVUpgradeWarningModal';

const sourceFromAllowedFeature = (
	reasonType: ValueOf<typeof AllowedFeature>,
): ValueOf<typeof UpgradeButtonSource> => {
	switch (reasonType) {
		default:
		case AllowedFeature.ADD_ITEM:
			return UpgradeButtonSource.UPGRADE_REQUIRED_ITEM_LIMIT_MODAL;
		case AllowedFeature.ADD_BOARD:
			return UpgradeButtonSource.UPGRADE_REQUIRED_BOARD_LIMIT_MODAL;
		case AllowedFeature.PRINT:
			return UpgradeButtonSource.UPGRADE_REQUIRED_PRINT_MODAL;
		case AllowedFeature.PRIVATE_ITEM:
		case AllowedFeature.PRIVATE_BOARD:
			return UpgradeButtonSource.UPGRADE_REQUIRED_PRIVATE_MODAL;
		case AllowedFeature.SHARED_BOARD:
			return UpgradeButtonSource.UPGRADE_REQUIRED_SHARED_MODAL;
		case AllowedFeature.MANAGE_TEAM:
			return UpgradeButtonSource.UPGRADE_REQUIRED_MANAGE_TEAM_MODAL;
		case AllowedFeature.CREATE_SITE:
			return UpgradeButtonSource.UPGRADE_REQUIRED_CREATE_SITE_MODAL;
		case AllowedFeature.RIGHT_CLICK:
			return UpgradeButtonSource.UPGRADE_REQUIRED_RIGHT_CLICK_MODAL;
		case AllowedFeature.HIDE_ASSETS:
			return UpgradeButtonSource.UPGRADE_REQUIRED_HIDE_ASSETS_MODAL;
	}
};

const formatFeatureName = (reasonType: ValueOf<typeof AllowedFeature>) => {
	return reasonType.replace(/_/g, ' ');
};

const getModalContent = (reasonType: ValueOf<typeof AllowedFeature>) => {
	const upsellBenefits = getUpsellBenefits();

	let title = (
		<div className="w-full min-w-[340px]">
			<>You discovered a Premium only feature</>
		</div>
	);
	let body = (
		<div className="flex max-w-[280px] flex-col">
			Upgrade to unlock {formatFeatureName(reasonType)} and other features made for you.
			<div className="mt-8">
				<SVUpgradeFeaturesList
					features={upsellBenefits}
					checkIconClassName="bg-[#0015FF]"
					className="space-y-2 text-gray-400"
					featureLabelClassName="text-xs"
				/>
			</div>
		</div>
	);

	return { title, body };
};

const SVUpgradeRequiredModal = SVModal.create(
	({ reasonType }: { reasonType: ValueOf<typeof AllowedFeature> }) => {
		const close = useModalClose();

		// If the user has reached the limit, we don't need to show the modal ( has been handled by the warning modal)
		if (
			reasonType == AllowedFeature.ADD_BOARD ||
			reasonType == AllowedFeature.ADD_ITEM ||
			reasonType == AllowedFeature.MANAGE_TEAM ||
			reasonType == AllowedFeature.CREATE_SITE
		) {
			close();
			return null;
		}

		const { title, body } = getModalContent(reasonType);

		const button = (
			<SVTrackedUpgradeButtonContainer
				source={sourceFromAllowedFeature(reasonType)}
				onClick={close}
				className="w-fit"
			>
				Upgrade and continue
			</SVTrackedUpgradeButtonContainer>
		);

		return <ModalContent title={title} body={body} button={button} />;
	},
	{
		modalClassName: 'max-w-[380px] -sm:max-w-full w-full',
		use: SVModal.USES.SMALL,
	},
);

export default SVUpgradeRequiredModal;
